import type {
  KgInsightMention,
  KgInsightSummaryV2,
} from '@api/api/kg-insights';
import type { ThemeSchemaResponse } from '@api/api/theme-overview';

export const getMSProxyThemeIds = (theme: ThemeSchemaResponse): string[] => {
  const attachedThemes = [...(theme.metadata?.ms_attached_themes ?? [])].sort(
    (left, right) => left.rank - right.rank
  );
  const themeIds = attachedThemes.map(attachedTheme => attachedTheme.theme_id);

  if (themeIds.length === 0 && theme.metadata?.ms_primary_theme_id) {
    themeIds.push(theme.metadata.ms_primary_theme_id);
  }

  return [...new Set(themeIds)];
};

export const filterAndDeduplicateBasketMentions = (
  insights: KgInsightSummaryV2[],
  basketCompanies: Set<string>,
  proxyThemeIds: Set<string>
): KgInsightMention[] => {
  const seen = new Set<string>();
  const mentions: KgInsightMention[] = [];

  for (const insight of insights) {
    if (
      seen.has(insight.id) ||
      !insight.mentions?.some(
        mention =>
          mention.ref_type === 'entity' && basketCompanies.has(mention.ref_id)
      )
    ) {
      continue;
    }

    const themeMention = insight.mentions.find(
      mention =>
        mention.ref_type === 'theme' && proxyThemeIds.has(mention.ref_id)
    );
    if (!themeMention) {
      continue;
    }

    seen.add(insight.id);
    mentions.push({
      insight_id: insight.id,
      ref_type: themeMention.ref_type,
      ref_id: themeMention.ref_id,
      source: themeMention.source,
      sentiment: themeMention.sentiment ?? insight.sentiment,
      category: insight.category,
      created_at: insight.created_at,
    });
  }

  return mentions;
};
